"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CfgCurrencyListRu = /** @class */ (function () {
    function CfgCurrencyListRu() {
    }
    CfgCurrencyListRu.getLangData = function () {
        return {
            document_title: "Валюты",
            editor: {
                breadcrumb: {
                    new_currency: ["Создание валюты"],
                    edit_currency: ["Редактирование валюты"]
                },
                message: {
                    currency_added: "Валюта добавлена!",
                    currency_changed: "Валюта изменена!"
                },
                error: {
                    field_title_empty: "Поле [название] не заполнено!",
                    field_iso_empty: "Поле [iso] не заполнено!",
                    field_symbol_empty: "Поле [symbol] не заполнено!",
                    field_rate_empty: "Поле [rate] не заполнено!"
                },
                title: {
                    new_currency: "Добавить валюту",
                    edit_currency: "Изменить валюту",
                },
                fields: {
                    title: {
                        caption: "Название:",
                        placeholder: "Введите название",
                    },
                    iso: {
                        caption: "ISO:",
                        placeholder: "Введите iso",
                    },
                    symbol: {
                        caption: "Символ:",
                        placeholder: "Введите символ"
                    },
                    exchange_rate: {
                        caption: "Курс обмена:",
                        placeholder: "Введите курс обмена валюты"
                    }
                },
                checkboxes: {
                    is_deprecated: "Валюта устарела",
                    is_fun: "Развлекательная валюта"
                },
                buttons: {
                    save: "Сохранить",
                    create: "Создать",
                    back: "Вернуться",
                }
            },
            list: {
                message: {
                    set_as_actual_fmt: "Валюта {0} помечена как актуальная",
                    set_as_deprecated_fmt: "Валюта {0} помечена как устаревшая",
                    currency_deleted_fmt: "Валюта {0} была успешно удалена",
                    currency_imported_fmt: "Валюты импортированы. Добавлено: {0}. Обновлено: {1} !",
                    currency_loaded: "Валюты загружены с сервера !",
                    set_all_currency_is_deprecated: "Все валюты помечены как устаревшие !",
                    set_all_currency_is_actual: "Все валюты помечены как актуальные !"
                },
                rows: {
                    title: "Название",
                    iso: "ISO",
                    symbol: "Символ",
                    exchange_rate: "Курс",
                    is_base: {
                        title: "Базовая",
                        view: {
                            no: "Нет",
                            yes: "Да",
                        },
                        filter: {
                            base: "Базовая",
                            derivative: "Производная"
                        }
                    },
                    is_fun: {
                        title: "Демо-валюта",
                        view: {
                            no: "Нет",
                            yes: "Да",
                        },
                        filter: {
                            demo: "Демо",
                            money: "Риал",
                        }
                    },
                    is_actual: {
                        title: "Актуальная",
                        menu: {
                            actual: {
                                menu: "Пометить как актуальный",
                                text: "Да"
                            },
                            deprecate: {
                                menu: "Пометить как неактуальные",
                                text: "Нет",
                            }
                        },
                        filter: {
                            actual: "Актуальная",
                            deprecate: "Устаревшая",
                        }
                    },
                    updated: "Изменен",
                    action: {
                        title: "Действия",
                        edit: "Изменить",
                        delete: {
                            hint: "Удалить",
                            confirm: "Удалить эту запись ?",
                        }
                    }
                },
                toolbars: {
                    hints: {
                        create: "Создать",
                        refresh: "Обновить",
                    },
                    import_all: {
                        confirm_title: "Импортировать валюты ?",
                        ok_text: "Да",
                        cancel_text: "Нет",
                        button_hint: "Импортировать валюты"
                    },
                    lock_all: {
                        confirm_title: "Отметить как не актуальные ?",
                        ok_text: "Да",
                        cancel_text: "Нет",
                        button_hint: "Отметить как не актуальные"
                    },
                    unlock_all: {
                        confirm_title: "Отметить как актуальные ?",
                        ok_text: "Да",
                        cancel_text: "Нет",
                        button_hint: "Отметить как актуальные"
                    }
                },
                footer: {
                    title_fmt: "Отображается на странице : {0} записей",
                },
                details: {
                    created: "Создан:",
                    changed: "Изменен:",
                }
            }
        };
    };
    return CfgCurrencyListRu;
}());
exports.CfgCurrencyListRu = CfgCurrencyListRu;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_currency/ui/lang/CfgCurrencyListRu.ts
// module id = 2043
// module chunks = 0